import { render } from "./BaseTableHeaderCondensed.vue?vue&type=template&id=3b6878ea"
import script from "./BaseTableHeaderCondensed.vue?vue&type=script&lang=js"
export * from "./BaseTableHeaderCondensed.vue?vue&type=script&lang=js"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__